function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#231F20",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.6 9.3c0 .6-.5 1.2-1.1 1.2H6.8c-.6 0-1.1-.5-1.1-1.2V0h12v9.3h-.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 21.7c0 1.3-1 2.3-2.2 2.3H2.2C1 24 0 23 0 21.7V2.3C0 1 1 0 2.2 0H4c.3 0 .5.2.5.5v8.8c0 1.3 1 2.3 2.2 2.3h9.9c1.2 0 2.2-1.1 2.2-2.3V0h.8c.3 0 .6.1.8.3l3.4 3.5c.1.2.2.5.2.8v17.1z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;